export enum Category {
    Endurance = "Endurance",
    Strength = "Strength",
    Mobility = "Mobility",
    Relaxation = "Relaxation",
    Coordination = "Coordination",
    Ai = "Ai",
}

export type AiCategory = Category | "discreet";

export interface CategorySessionSummary {
    totalDuration: number;
    exercises: ExerciseInSession[];
}

export interface Session {
    exercises: ExerciseInSession[];
}

export interface DbSession {
    id: number;
    durationTotal: number;
    durationEndurance: number;
    durationStrength: number;
    durationCoordination: number;
    durationRelaxation: number;
    durationMobility: number;
    durationAi: number;
    exercises: Exercise[];
    aiExercises: AiExerciseId[];
    createdAt: string;
}

export interface Setting {
    id: number;
    name: string;
    discreet: boolean;
    favourite: boolean;
    categories: Category[];
}

export interface Exercise {
    id: number;
    nameDe: string;
    nameEn: string;
    category: Category;
    descriptionDe: string;
    descriptionEn: string;
    image: string;
    discreet: boolean;
    equipmentDe?: string;
    equipmentEn?: string;
    recommendationDe?: string;
    recommendationEn?: string;
    source?: string;
}

export type ExerciseInSession = (Exercise | AiExercise) & { duration: number };

export type AiExerciseId = `ai-${string}`;

export type ExerciseId = ExerciseInSession["id"];

export interface AiExercise {
    id: AiExerciseId;
}

export interface LocationSessionState {
    session?: DbSession;
    error?: unknown;
}

export interface Settings {
    discreet: "yes" | "no";
    favourite: "yes" | "no";
    categories: Category[];
}

export interface SettingsLocationState {
    settings: Settings;
}

export interface AiExerciseDataState extends SettingsLocationState {
    photo: string;
}

export interface ExerciseIdWithName {
    id: ExerciseId;
    nameEn: string;
    nameDe: string;
}

export interface SettingsQueryData {
    countedSettings: {
        nodes: Setting[];
        totalCount: number;
    };
}

export interface LocationSettingState {
    setting?: Setting;
    error?: unknown;
}

export enum AppEvent {
    TraditionalSessionStarted = "TraditionalSessionStarted",
    AiSessionStarted = "AiSessionStarted",
    ExerciseStarted = "ExerciseStarted",
    ExerciseSkipped = "ExerciseSkipped",
    ExerciseFinished = "ExerciseFinished",
    SessionCompleted = "SessionCompleted",
    SessionCancelled = "SessionCancelled",
    FavouriteAdded = "FavouriteAdded",
    FavouriteRemoved = "FavouriteRemoved",
    ExcludedAdded = "ExcludedAdded",
    ExcludedRemoved = "ExcludedRemoved",
    AppLoaded = "AppLoaded",
    TabSessionStarted = "TabSessionStarted",
    AppUnloaded = "AppUnloaded",
    PathChanged = "PathChanged",
}
